import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd'
import {withTranslation} from 'react-i18next'
import { PlusOutlined, DeleteOutlined, UpOutlined, DownOutlined } from '@ant-design/icons'

@inject('remarkTemplateListStore')
@observer
class FormModal extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
    const {remarkTemplateListStore, title} = this.props
    const {detailsObj} = remarkTemplateListStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        questionName: detailsObj?.questionName,
        questionContent: JSON.parse(JSON.stringify(detailsObj?.questionContent || []))
      })
    } else {
      this.formRef.current.setFieldsValue({
        questionContent: [{
          question_name: '',
          question_type: '',
          answer_item: [],
          data: null
        }]
      })
    }
  }

  handleOk = () => {
    const {remarkTemplateListStore, handleCancel, title} = this.props
    const {detailsObj} = remarkTemplateListStore
    
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "questionName": fieldsValue.questionName,
        "questionContent": fieldsValue.questionContent,
      }
      if (title === 'edit') {
        remarkTemplateListStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        remarkTemplateListStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }

  // 更新问题
  handleUpdateQuestion = (index, field, value) => {
    const questionContent = this.formRef.current.getFieldValue('questionContent')
    
    // 当问题类型从输入改为单选/多选时，添加一个默认选项
    if (field === 'question_type' && (value === 'radio' || value === 'select')) {
      questionContent[index].answer_item = ['']
    } else if (field === 'question_type' && (value === 'input')) {
      questionContent[index].answer_item = []
    }
    this.formRef.current.setFieldsValue({
      'questionContent': questionContent
    })
  }

  render() {
    const { addModalVisible, handleCancel, title, t } = this.props
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`general.edit`) + t(`menu.remarkTemplateList`) : t(`general.addData`) + t(`menu.remarkTemplateList`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width='50%'
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addRemarkTemplate">
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item name="questionName" label={t(`questionnaire.name`)} 
                  rules={[{ 
                    required: true, 
                    message: t(`general.pleaseEnter`), 
                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                  }]}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20}}
                >
                  <Input
                    placeholder={t(`general.pleaseEnter`)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.List name="questionContent">
              {(fields, { add, remove, move }) => (
                <>
                  {fields.map((field, qIndex) => {
                    const question = fields?.[qIndex] || {}
                    return (
                      <Row key={field.key} gutter={[16, 16]} style={{background: '#f5f5f5', border: 'none', padding: '10px 10px 0', marginBottom: 10, alignItems: 'center', justifyContent: 'center' }}>
                        <Col span={17}>
                            <Row gutter={[0, 0]}>
                              <Col span={16}>
                                <Form.Item 
                                  label={t(`questionnaire.questionName`)} 
                                  name={[field.name, 'question_name']}
                                  rules={[{ 
                                    required: true, 
                                    message: t(`general.pleaseEnter`), 
                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                  }]}
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 16}}
                                >
                                  <Input placeholder={t(`general.pleaseEnter`)}/>
                                </Form.Item>
                              </Col>
                              <Col span={16}>
                                <Form.Item 
                                  label={t(`questionnaire.questionType`)} 
                                  name={[field.name, 'question_type']}
                                  rules={[{ required: true, message: t(`general.pleaseSelect`) }]}
                                  labelCol={{ span: 8 }}
                                  wrapperCol={{ span: 16}}
                                >
                                  <Select  onChange={(value) => this.handleUpdateQuestion(qIndex, 'question_type', value)}>
                                    <Select.Option value="radio">{t(`questionnaire.single`)}</Select.Option>
                                    <Select.Option value="select">{t(`questionnaire.multiple`)}</Select.Option>
                                    <Select.Option value="input">{t(`questionnaire.input`)}</Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                            {question.question_type !== 'input' && (
                              <Form.List name={[field.name, 'answer_item']}>
                                {(answerFields, { add: addAnswer, remove: removeAnswer, move: moveAnswer }) => (
                                  <>
                                    {answerFields.map((answerField, oIndex) => (
                                      <Row key={answerField.key} gutter={[10, 0]}>
                                        <Col span={16}>
                                          <Form.Item 
                                            label={oIndex === 0 ? t(`questionnaire.option`) : ''} 
                                            name={[answerField.name]}
                                            rules={[{ 
                                              required: true, 
                                              message: t(`general.pleaseEnter`), 
                                              pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                            }]}
                                            labelCol={{ span: 8 }}
                                            wrapperCol={oIndex === 0 ? { span: 24 } : { span: 16, offset: 8 }}
                                          >
                                            <Input placeholder={t(`general.pleaseEnter`)} />
                                          </Form.Item>
                                        </Col>
                                        <Col>
                                          <Button 
                                            icon={<PlusOutlined />} 
                                            onClick={() => addAnswer()}
                                          />
                                        </Col>
                                        <Col>
                                          <Button 
                                            icon={<DeleteOutlined />} 
                                            onClick={() => removeAnswer(oIndex)}
                                            disabled={answerFields.length === 1 && oIndex === 0}
                                          />
                                        </Col>
                                        <Col>
                                          <Button 
                                            icon={<UpOutlined />} 
                                            onClick={() => moveAnswer(oIndex, oIndex - 1)}
                                            disabled={oIndex === 0}
                                          />
                                        </Col>
                                        <Col>
                                          <Button 
                                            icon={<DownOutlined />} 
                                            onClick={() => moveAnswer(oIndex, oIndex + 1)}
                                            disabled={oIndex === answerFields.length - 1}
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </>
                                )}
                              </Form.List>
                            )}
                        </Col>
                        <Col span={7} style={{ textAlign: 'right' }}>
                          <Button 
                            icon={<PlusOutlined />} 
                            onClick={() => add()}
                            title={t(`general.add`)}
                            style={{ marginRight: 10 }}
                          />
                          <Button 
                            icon={<DeleteOutlined />} 
                            onClick={() => remove(field.name)}
                            title={t(`general.delete`)}
                            disabled={fields.length === 1 && field.name === 0}
                            style={{ marginRight: 10 }}
                          />
                          <Button 
                            icon={<UpOutlined />} 
                            onClick={() => move(field.name, field.name - 1)}
                            disabled={field.name === 0}
                            style={{ marginRight: 10 }}
                          />
                          <Button 
                            icon={<DownOutlined />} 
                            onClick={() => move(field.name, field.name + 1)}
                            disabled={field.name === fields.length - 1}
                          />
                        </Col>
                      </Row>
                    )
                  })}
                </>
              )}
            </Form.List>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
